class DepartmentForOfficeRoom {
  id?: string;

  name = '';
}

export default DepartmentForOfficeRoom;
